import AbstractInterieur from "./AbstractInterieur";
import Helper from '../model/Helper'

export default class Schubladenbox extends AbstractInterieur {

    constructor(vsData) {
        super(vsData);
    }

    onDragBegin() {
        super.onDragBegin();
        APP.model.showDoorsClosed(false);
    }

    onDrop() {
        super.onDrop();
        if (!this.vsData.isDropped) {
            this.onTap();
            this.vsData.isDropped = true;
        }
    }

    onTap() {
        // delay damit eventuelle Fehler direkt angezeigt werden (tritt auf, wenn die Schranktiefe 42 ist,
        // und eine Kleiderstange vorhanden ist, aber noch keine Front existiert)
        // bei onDrop ist die Schubladenbox nämlich noch nicht im Element eingefügt
        _.delay(()=>this.showDialog(),100);
    }

    showDialog() {
        if (this.vsData.isOrphaned()) {
            return;
        }

        const warnData = this.vsData.schrank.options.getValue('schublade_tiefe_hinweis').split(',');
        const warnDepth = (this.vsData.product.Art === 'innenliegend') ? warnData[1] : warnData[0];
        let warnText = '';
        if (this.vsData.size.z > parseFloat(warnDepth)) {
            warnText = `<p>${I18N('dialogSchubladeMaxSchrankDepthText', warnData[2], warnData[3])}</p>`;
        }


        // const checkHeight = (input) => {
        //     const gewuenschteHoehe = input.number('hoehe');
        //     const anzahlRadio = parseInt(input.radioOption('faecher'));
        //     let calc = this.vsData.calcFaecherHoehe(anzahlRadio, gewuenschteHoehe);
        //     if (calc.anzahl!=anzahlRadio) {
        //         input.message('hoehe', "Ungültige Höhe.");
        //         return;
        //     }
        //     input.message('hoehe', Math.abs(calc.hoehe-gewuenschteHoehe)>0.1 ? I18N('dialogSchubladenboxKorrigiert', Helper.round(calc.hoehe)) /*'Die Fachhöhe wurde auf ' + hoehe + ' korrgiert.'*/ : '');
        //     $('#cfg-dialog #nutzhoehe').html(Helper.round(calc.hoehe - APP.settings.getFloat('schublade_nutzhoehe_offset')));
        // };

        const checkHeight = (anzahl, gewuenschteHoehe) => {
            let calc = this.vsData.calcFaecherHoehe(anzahl, gewuenschteHoehe);
            if (calc.anzahl!=anzahl) {
                return {
                    message: "Ungültige Höhe."
                };
            }
            return {
                message:  Math.abs(calc.hoehe-gewuenschteHoehe)>0.1 ? I18N('dialogSchubladenboxKorrigiert', Helper.round(calc.hoehe)) /*'Die Fachhöhe wurde auf ' + hoehe + ' korrgiert.'*/ : '',
                nutzhoehe: Helper.round(calc.hoehe - this.vsData.schrank.options.getFloat('schublade_nutzhoehe_offset'))
            };
        };

        APP.uiHandler.sidebar('schublade', this);

        //
        // APP.uiHandler.dialog({
        //     title: I18N('dialogSchubladenboxTitle'),
        //     text: warnText + I18N('dialogSchubladenboxText'),
        //     inputs: [
        //         {
        //             id: 'faecher',
        //             label: I18N('items'),
        //             radio: true,
        //             options: faecherOptions,
        //             events: {change: checkHeight}
        //         },
        //         {
        //             id: 'hoehe',
        //             label: I18N('dialogSchubladenboxHeight'),
        //             text: true,
        //             value: Helper.round(this.vsData.faecherHoehe),
        //             events: {
        //                 keyup: checkHeight
        //             }
        //         },
        //     ],
        //     buttons: [
        //         {
        //             style: 'primary',
        //             label: I18N('OK'),
        //             click: input => {
        //                 const anzahl = parseInt(input.radio('faecher'), 10);
        //                 const hoehe = input.number('hoehe');
        //                 APP.model.tryCompile(()=>this.vsData.setFaecher(anzahl, hoehe));
        //             }
        //         }
        //     ]
        // });
    }
}
